import { matchPath } from 'react-router-dom';
import { ScoringResponse } from 'shared/model/scoring';

import { ROUTES } from '../../../routes/consts';
import { API } from '../../api/loan';
import { HASACCESS_TOVARIABLES, processEventToPageMatcher, STEPS } from '../../consts';
import { EProductStatus, ESocketEvent } from '../../enum';
import { redirect } from '../../utils/redirect';

import { IUtilsParams } from './models';

export const getNewUrl = (path: string, params: IUtilsParams) => {
  const { lang, productCode } = params;
  return `/${lang}/order/${productCode}${path}`;
};

// TODO: Remove this logic -> discuss with BE better approach for redirection
export const redirectFlow = (step: ESocketEvent, params: IUtilsParams) => {
  const { processId, rest, productCode } = params;
  rest.get<ScoringResponse>(API.loan.getOrderDetail(processId)).then(({ data: { progressingStatus, step: stepFromBE, productDetail } }) => {
    const innerRedirect = productCode === productDetail?.code;
    let newStep = step;
    if ((progressingStatus === EProductStatus.IN_PROGRESS && stepFromBE !== step) || progressingStatus === EProductStatus.REDIRECTION) {
      newStep = stepFromBE;
    } else if (progressingStatus === EProductStatus.ERROR) {
      newStep = ESocketEvent.ERROR;
    } else if (progressingStatus === EProductStatus.END || progressingStatus === EProductStatus.COMPLETED) {
      newStep = ESocketEvent.END;
    }
    const url = Object.keys(STEPS).find(p => !!matchPath(p, window.location.pathname));
    const currentUrlStep = url ? STEPS[url] : undefined;
    if (!currentUrlStep || !processEventToPageMatcher(newStep).includes(currentUrlStep)) {
      redirectTo(newStep, { ...params, productCode: productDetail?.code || productCode }, innerRedirect);
    }
  });
};

export const redirectTo = (step: ESocketEvent, params: IUtilsParams, innerRedirect = true) => {
  const { processId, rest, navigate } = params;
  const redirectMethod = innerRedirect ? navigate : redirect;

  const redirectDVS = () => {
    rest.get<ScoringResponse>(API.loan.getOrderDetail(processId)).then(({ data }) => {
      if (data.dvsDetail?.dvsLink) {
        redirect(data.dvsDetail.dvsLink);
      } else {
        redirectMethod(getNewUrl(ROUTES.FINAL.PATH, params));
      }
    });
  };

  const errorCase = () => {
    if (localStorage.getItem(HASACCESS_TOVARIABLES) === 'false') {
      redirectMethod(getNewUrl(ROUTES.FINAL.PATH, params));
    } else {
      rest.get<ScoringResponse>(API.loan.getOrderDetail(processId)).then(() => {
        redirectMethod(getNewUrl(ROUTES.FINAL.PATH, params));
      });
    }
  };

  switch (step) {
    case ESocketEvent.OTP:
      redirectMethod(getNewUrl(ROUTES.OTP.PATH, params));
      break;

    case ESocketEvent.CALCULATOR:
      redirectMethod(getNewUrl(ROUTES.SCORING.PATH, params));
      break;

    case ESocketEvent.CUSTOMER_INFO:
      redirectMethod(getNewUrl(ROUTES.ORDER_FORM.PATH, params));
      break;

    case ESocketEvent.DVS:
      redirectDVS();
      break;

    case ESocketEvent.YES_CARD_TRANSFER:
      redirectMethod(getNewUrl(ROUTES.FORMALIZING_CARD.PATH, params));
      break;

    case ESocketEvent.NO_CARD_TRANSFER:
      redirectMethod(getNewUrl(ROUTES.FORMALIZATION_OPTION.PATH, params));
      break;

    case ESocketEvent.ERROR:
      errorCase();
      break;

    case ESocketEvent.END:
      redirectMethod(getNewUrl(ROUTES.FINAL.PATH, params));
      break;

    // TODO: find out when we got this event from BE -> write doc
    case ESocketEvent.REDIRECTION:
      redirectFlow(step, params);
      break;

    default:
      break;
  }
};
